import { ToolBarButton } from 'components/ToolBarButton'
import { PenTool } from 'react-feather'

export const AnnotationsButton = () => {
  const handleClick = () => {
    console.info('ANNOTATIONS button clicked.')
  }

  return (
    <ToolBarButton
      disabled={false}
      label="ANNOTATIONS"
      icon={PenTool}
      tooltipText="ANNOTATIONS"
      clickCallback={handleClick}
      badgeStatus="info"
    />
  )
}
